<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
        <path
            d="M3 5H21M9 19H15M6 12H18"
            stroke="black"
            stroke-width="2.5"
            stroke-linecap="round"
        />
    </svg>
</template>
